import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Styling",
description: "Learn how to style the Freon web app and editor using SCSS or CSS, including light and dark theme customization, Flowbite integration, and overriding Freon component styles.",
tags: [ "styling", "SCSS", "CSS", "themes", "light mode", "dark mode", "editor styling", "Flowbite", "Material UI", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T19:06:34.439Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};